import React from "react";
import { css, Global } from "@emotion/react";

interface DynamicCalendarStylesProps {
  readonly darkMode: boolean;
}

export function DynamicCalendarStyles({ darkMode }: DynamicCalendarStylesProps) {
  return <Global styles={css`
        .sx__calendar {
          --sx-color-background: ${darkMode ? '#1a1a1a' : '#ffffff'} !important;
          --sx-color-background-secondary: ${darkMode ? '#2d2d2d' : '#f5f5f5'} !important;
          --sx-color-border: ${darkMode ? '#ffffff1f' : '#e0e0e0'} !important;
          --sx-color-text: ${darkMode ? '#ffffff' : '#000000'} !important;
          --sx-color-text-secondary: ${darkMode ? '#b0b0b0' : '#666666'} !important;
          --sx-color-hover: ${darkMode ? '#333333' : '#f0f0f0'} !important;
          --sx-color-selected: ${darkMode ? '#444444' : '#e3f2fd'} !important;
          --sx-color-background-inactive: ${darkMode ? '#1a1a1a' : '#fafafa'} !important;
          --sx-color-text-inactive: ${darkMode ? '#555555' : '#999999'} !important;
          --sx-color-surface-dim: ${darkMode ? '#2d2d2d' : '#f5f5f5'} !important;
          --sx-internal-color-text: ${darkMode ? '#ffffff' : '#000000'} !important;
          --sx-color-neutral: ${darkMode ? '#ffffff' : '#000000'} !important;
          --sx-color-background-input-label: ${darkMode ? '#2d2d2d' : '#ffffff'} !important;
          --sx-color-primary: #00b2a0 !important;
          --sx-color-primary-container: #038C7F !important;
          --sx-color-on-primary-container: #ffffff !important;          
          --sx-border: 1px solid var(--sx-color-border);
        }
  
        .sx__event, .sx__month-grid-event, .sx__month-grid-cell {
          /* background-color: var(--sx-color-primary); */
        }
  
        .sx__date-picker-wrapper * {
          color: var(--sx-color-neutral)
        }
  
        .sx__date-input {
          background-color: var(--sx-color-background-input-label);
        }
  
        .sx__date-input-label {
          background-color: var(--sx-color-background-input-label);
        }
  
        .sx__month-grid-day__header-date{
          color: var(--sx-color-neutral)
        }
  
        .sx__calendar-header {
          background-color: var(--sx-color-background-input-label);
          border-bottom: 1px solid ${darkMode ? '#404040' : '#e0e0e0'} !important;
          color:  var(--sx-color-neutral)
        }
        .sx__view-selection-label {
          background-color: var(--sx-color-background-input-label);
          color:  var(--sx-color-neutral);
          text-transform: capitalize !important;
        }
  
        .sx__event-modal.is-open {
          color: var(--sx-color-text);
        }
  
        .sx__today-button {
          
          &:hover {
            background-color: inherit !important;
          }
          
          &:focus {
            background-color: transparent !important;
          }
          
          &:active {
            background-color: transparent !important;
          }
        }
  
        .sx__view-selection-item:hover {
          background-color: var(--sx-color-primary-container);
        }
  
        .sx__view-selection-selected-item:hover {
          background-color: inherit !important;
        }
        
       .sx__view-selection-item.is-selected{
          background-color: var(--sx-color-primary);
          color: var(--sx-color-on-primary-container);
        }
  
        .sx__month-grid-day__header-date.sx__is-today {
          color: #ffffff !important;
        }
  
        .sx__calendar-week-days {
          background-color: ${darkMode ? '#2a2a2a' : '#f5f5f5'} !important;
          color: var(--sx-color-neutral);
        }
        .sx__month-grid-day__header-day-name {
          color: var(--sx-color-neutral);
        }

        /* Capitalizar primeira letra dos nomes no header */
        .sx__month-grid-day__header-day-name,
        .sx__view-selection-label,
        .sx__calendar-header .sx__view-selection-label,
        .sx__date-picker-month-view-month-name,
        .sx__calendar-week-days span,
        .sx__month-agenda-day__day-name,
        .sx__week-grid__header-weekday,
        .sx__day-view-header-day-info,
        .sx__calendar-header-content {
          text-transform: capitalize !important;
        }
        
        /* Forçar capitalização no nome do mês e ano no header principal */
        .sx__calendar-header .sx__view-selection-label,
        .sx__view-selection button {
          text-transform: capitalize !important;
        }

        /* Capitalizar nome do mês e ano no date picker (calendário aberto) */
        .sx__date-picker-header,
        .sx__date-picker-month-view-header,
        .sx__date-picker-year-view-header,
        .sx__date-picker .sx__date-picker-header-content,
        .sx__date-picker-header button,
        .sx__date-picker__month-view-header__month-year {
          text-transform: capitalize !important;
        }
  
      `}
  />
}